import React from "react";
import {
  CircularProgress,
  Paper,
  Modal,
  Backdrop,
  Fade,
  TextField,
  Grid,
  Button,
  MenuItem,
} from "@material-ui/core";
import { connect } from "react-redux";
import { updateContract } from "@redux/actions";
import withStyles from "@material-ui/core/styles/withStyles";
import { toast } from "react-toastify";
import { CONTRACTS, CONTRACT_STATUS } from "@utils/constants";

const modalStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: "Arial",
};

const modalBody = {
  paddingLeft: "15px",
  paddingRight: "15px",
  paddingBottom: "15px",
  minWidth: "530px",
  minHeight: "300px",
};

const modalHeader = {
  background: "#232F3E",
  color: "white",
  textAlign: "center",
  paddingTop: "11px",
  paddingBottom: "0.02px",
};

const styles = (theme) => ({
  paper: {
    maxWidth: 500,
    margin: "auto",
    overflow: "hidden",
    display: "flex",
    flexWrap: "wrap",
    padding: theme.spacing.unit,
    boxShadow: "none !important",
  },
  form: {
    marginTop: theme.spacing.unit,
  },

  textField: {
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    width: 450,
  },
  submitButton: {
    margin: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
  },
  switch: {
    marginLeft: theme.spacing.unit,
  },
  dropDownField: {
    marginLeft: theme.spacing.unit * 2,
    marginTop: "15px !important",
    width: 200,
  },
  dropDownText: {
    marginLeft: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 0.5,
    fontSize: "1rem",
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit * 2,
    width: 450,
  },
});

class ViewContract extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contract: this.props.contractData?.contract,
      started_at: this.props.contractData?.started_at,
      ended_at: this.props.contractData?.ended_at,
      renewed_at: this.props.contractData?.renewed_at || null,
      permanent_set_at: this.props.contractData?.permanent_set_at || null,
      status: this.props.contractData?.status || "active",
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.contractData !== this.props.contractData) {
      this.setState({
        contract: this.props.contractData?.contract,
        started_at: this.props.contractData?.started_at,
        ended_at: this.props.contractData?.ended_at,
        renewed_at: this.props.contractData?.renewed_at || null,
        permanent_set_at: this.props.contractData?.permanent_set_at || null,
        status: this.props.contractData?.status || "active",
      });
    }
  }
  handleSubmit = async (event) => {
    event.preventDefault();
    const payload = {
      ...this.state,
      employeeId: this.props.contractData.employee_id,
      _id: this.props.contractData._id,
    };
    const response = await this.props.updateContract(payload);
    const { message, success } = response.data;
    toast(message, {
      position: "bottom-left",
      autoClose: 2500,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "dark",
      type: success ? "success" : "error",
    });
    setTimeout(() => {
      this.props.openModal();
    }, 3000);
  };
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };
  handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    this.setState({
      [name]: checked,
    });
  };

  render() {
    const { classes, isLoading } = this.props;
    return (
      <div>
        <Modal
          open={isLoading}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
          style={modalStyle}
        >
          <Fade in={true}>
            <Paper elevation={1} variant="normal" square>
              <div style={modalHeader}>
                <p>Contract Details</p>
              </div>
              <div style={modalBody}>
                {isLoading ? ( // Show a loader if isLoading is true
                  <div className="LoaderWrapper">
                    <CircularProgress color="primary" />
                  </div>
                ) : (
                  <Paper className={classes.paper}>
                    <form
                      className={classes.form}
                      autoComplete="off"
                      onSubmit={this.handleSubmit}
                    >
                      <TextField
                        name="contract"
                        label="Contract"
                        fullWidth
                        className={classes.textField}
                        defaultValue={this.props.contractData?.contract}
                        value={this.state.contract}
                        onChange={this.handleChange}
                        margin="normal"
                        select
                      >
                        {CONTRACTS.map((contract, index) => (
                          <MenuItem key={index} value={contract}>
                            {contract}
                          </MenuItem>
                        ))}
                      </TextField>

                      <TextField
                        id="started_at"
                        name="started_at"
                        label="Starting Date"
                        type="date"
                        required
                        defaultValue={
                          this.props.contractData?.started_at?.split("T")[0]
                        }
                        onChange={this.handleChange}
                        className={classes.textField}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                      <TextField
                        id="ended_at"
                        name="ended_at"
                        label="Ending Date"
                        type="date"
                        required
                        defaultValue={
                          this.props.contractData?.ended_at?.split("T")[0]
                        }
                        onChange={this.handleChange}
                        className={classes.textField}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                      <TextField
                        id="renewed_at"
                        name="renewed_at"
                        label="Renewal Date"
                        type="date"
                        value={this.state.renewed_at?.split("T")[0] || ""}
                        onChange={this.handleChange}
                        className={classes.textField}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />

                      <TextField
                        name="status"
                        label="Status"
                        fullWidth
                        className={classes.textField}
                        value={this.state.status}
                        onChange={this.handleChange}
                        margin="normal"
                        select
                      >
                        <MenuItem value="active">Active</MenuItem>
                        {CONTRACT_STATUS.map((status, index) => (
                          <MenuItem key={index} value={status}>
                            {status.charAt(0).toUpperCase() +
                              status.slice(1).toLowerCase()}
                          </MenuItem>
                        ))}
                      </TextField>
                      <br />
                      <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="flex-end"
                      >
                        <Grid item>
                          <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.submitButton}
                            onClick={this.props.openModal}
                          >
                            Close
                          </Button>
                          <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.submitButton}
                          >
                            Update
                          </Button>
                        </Grid>
                      </Grid>
                    </form>
                  </Paper>
                )}
              </div>
            </Paper>
          </Fade>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = () => {
  return {};
};

export default connect(mapStateToProps, { updateContract })(
  withStyles(styles)(ViewContract)
);
